module.exports = __webpack_public_path__ + "img/headerBg.15b38017.png";